export const RETREIVE_PRODUCTS_ACTION = 'RETREIVE_PRODUCTS_ACTION';
export const RETREIVE_PRODUCTS_MUTATION = 'RETREIVE_PRODUCTS_MUTATION';
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_TYPED_PRODUCTS = 'GET_TYPED_PRODUCTS';
export const GET_FILTERED_PRODUCTS_BY_CATEGORY = 'GET_FILTERED_PRODUCTS_BY_CATEGORY';
export const GET_FILTERED_PRODUCTS_BY_CATEGORY_CASE = 'GET_FILTERED_PRODUCTS_BY_CATEGORY_CASE';
export const GET_FILTERED_PRODUCTS_BY_FEATURES = 'GET_FILTERED_PRODUCTS_BY_FEATURES';
export const GET_FILTERED_PRODUCTS = 'GET_FILTERED_PRODUCTS';
export const GET_PRODUCTS_WITH_DISCOUNT = 'GET_PRODUCTS_WITH_DISCOUNT';
export const RETREIVE_CATEGORIES_ACTION = 'RETREIVE_CATEGORIES_ACTION';
export const RETREIVE_CATEGORIES_MUTATION = 'RETREIVE_CATEGORIES_MUTATION';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const SET_SHOP_LOADING_TO_TRUE = 'SET_SHOP_LOADING_TO_TRUE';
export const SET_SHOP_LOADING_TO_FALSE = 'SET_SHOP_LOADING_TO_FALSE';
export const GET_SHOP_LOADING = 'GET_SHOP_LOADING';
export const GET_FILTER = 'GET_FILTER';
export const SET_FILTER_CATEGORY_MUTATION = 'SET_FILTER_CATEGORY_MUTATION'
export const SET_FILTER_CATEGORY_ACTION = 'SET_FILTER_CATEGORY_ACTION'
export const SET_FILTER_TYPE_MUTATION = 'SET_FILTER_TYPE_MUTATION'
export const SET_FILTER_TYPE_ACTION = 'SET_FILTER_TYPE_ACTION'
export const SET_FEATURES_FILTER = 'SET_FEATURES_FILTER'
export const SET_FEATURES_FILTER_SELECTED = 'SET_FEATURES_FILTER_SELECTED'
export const GET_FEATURES_FILTER = 'GET_FEATURES_FILTER'
export const GET_FEATURES_FILTER_SELECTED = 'GET_FEATURES_FILTER_SELECTED'
export const RETREIVE_FEATURES_FILTER_ACTION = 'RETREIVE_FEATURES_FILTER_ACTION'
export const RETREIVE_FEATURES_FILTER_MUTATION = 'RETREIVE_FEATURES_FILTER_MUTATION'
export const SET_TYPES_FILTER_SELECTED = 'SET_TYPES_FILTER_SELECTED'
export const GET_TYPES_FILTER_SELECTED = 'GET_TYPES_FILTER_SELECTED'
export const GET_FILTERS_SELECTED = 'GET_FILTERS_SELECTED'
export const REMOVE_FILTER_ACTION = 'REMOVE_FILTER_ACTION'
export const CLEAR_FILTERS_ACTION = 'CLEAR_FILTERS_ACTION'
